import React, { useMemo } from "react";
import { GatsbyImage, getImage, withArtDirection } from "gatsby-plugin-image";
import { Link } from "./link";
import { graphql } from "gatsby";
import slugify from "@sindresorhus/slugify";

const BannerPushApp = ({ data, position }) => {
  const deskimage = data.bookletSection?.paImage;
  const mobileimage = data.bookletSection?.imageMobile;
  const images = useMemo(() => {
    if (!deskimage) return null;
    return mobileimage
      ? withArtDirection(getImage(deskimage.node), [
          {
            media: "(max-width: 800px)",
            image: getImage(mobileimage.node || deskimage.nodeMobile),
          },
        ])
      : getImage(deskimage.node);
  }, [deskimage, mobileimage]);

  return position === "pdp" ? (
    <>
      {data?.anchorDesktop && (
        <span id={slugify(data.anchorDesktop)} className="tabs__scroll-anchor" />
      )}
      <div className="product-detail__banner-app d-flex flex-column-reverse flex-lg-row justify-content-around text-center font-weight-bold">
        <div className="product-detail__app d-flex flex-column flex-fill justify-content-center align-items-center p-2">
          <GatsbyImage
            className="product-detail__logo-app"
            loading="eager"
            image={getImage(data.pdpSection?.pdpIconApp?.node)}
            alt={data.pdpSection?.pdpIconApp?.value.description}
          />
        </div>
        <div className="d-flex flex-column justify-content-center p-2 px-4 px-lg-3 py-lg-5 product-detail__text-wrapper">
          <span className="product-detail__app-name pt-4 pt-lg-5">{data.pdpSection?.pdpTitle}</span>
          <div className="product-detail__text">{data.pdpSection?.pdpAbstract}</div>
          <div className="d-flex justify-content-between justify-content-lg-start align-items-center flex-wrap pb-4 pb-lg-5">
            {data.appStoreImages?.map((badge, i) => (
              <Link to={badge.appStoreLink} key={i} target={badge.appStoreTarget}>
                <GatsbyImage
                  className="product-detail__download-img"
                  loading="eager"
                  image={getImage(badge.appStoreImage?.nodepdp)}
                  alt={badge.appStoreImage?.value.description}
                />
              </Link>
            ))}
          </div>
        </div>
      </div>
    </>
  ) : (
    <>
      <div className="container-fluid px-0">
        <div className="manuali-app__image-wrapper">
          <GatsbyImage
            className="manuali-app__image"
            image={images}
            alt={data.bookletSection?.paImage?.value.description}
          />
          <div className="manuali-app__icon">
            {/*  <GatsbyImage image={getImage(data.paTitle?.content.paIcon?.node)} alt={data.paTitle?.content.paIcon?.value.description} /> */}
            <img
              src={data.bookletSection?.paIcon?.node.publicURL}
              alt={data.bookletSection?.paIcon?.value.description}
            />
          </div>
        </div>
      </div>
      <div className="container mt-2">
        <div className="row text-center">
          <div className="col-12">
            <div className="d-flex justify-content-center flex-column mt-5">
              <p className="manuali-app__title">{data.bookletSection?.paTitle}</p>
              <span dangerouslySetInnerHTML={{ __html: data.bookletSection?.paAbstract }}></span>
              <div className="d-flex justify-content-center mt-2">
                {data.appStoreImages?.map((badge, i) => (
                  <Link
                    className="manuali-app__download-link"
                    to={badge.appStoreLink}
                    key={i}
                    target={badge.appStoreTarget}
                  >
                    <GatsbyImage
                      className="manuali-app__download-img"
                      loading="eager"
                      image={getImage(badge.appStoreImage?.node)}
                      alt={badge.appStoreImage?.value.description}
                    />
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BannerPushApp;

export const fragment = graphql`
  fragment ProductAppFragment on LiferayProductApp {
    paIdAttribute
    paIdOption
    haierStEcommLines {
      productLine
    }
    anchorDesktop
    anchorMobile
    bookletSection {
      paTitle
      paAbstract
      paIcon {
        node {
          publicURL
        }
        value {
          description
        }
      }
      paImage {
        node {
          gatsbyImageData(width: 1440, layout: FULL_WIDTH)
        }
        nodeMobile: node {
          gatsbyImageData(height: 220, aspectRatio: 3.64, layout: FULL_WIDTH)
        }
        value {
          description
        }
      }
      imageMobile {
        node {
          gatsbyImageData(width: 1440, layout: FULL_WIDTH)
        }
        value {
          description
        }
      }
    }
    appStoreImages {
      appStoreLink
      appStoreTarget
      appStoreImage {
        node {
          gatsbyImageData(height: 50, layout: CONSTRAINED)
          publicURL
        }
        nodepdp: node {
          gatsbyImageData(height: 40, layout: CONSTRAINED)
          publicURL
        }
        value {
          description
        }
      }
    }
    pdpSection {
      pdpTitle
      pdpAbstract
      pdpIconApp {
        node {
          gatsbyImageData(width: 1440, layout: CONSTRAINED)
          publicURL
        }
        value {
          description
        }
      }
    }
  }
`;
